import React, { Suspense, useEffect, useRef, useState } from "react";
import { getUserDataAPI } from "../../service/UserService";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
// import { useNavigate } from "react-router-dom";
import { dashboardBannerAPI } from "../../service/AuthService";
import {
  getAllMatchesOddsSoccerAPI,
  getAllMatchesOddsTennisAPI,
  getAllSoccerMatchListAPI,
  getAllTennisMatchListAPI,
} from "../../service/soccer&tennis";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import {
  getAllCricketMatchListAPI,
  getAllMatchesOddsCricketAPI,
} from "../../service/cricket";
import { useParams } from "react-router-dom";
import superover from "../../assets/Sample/superovernew.jpg";
import teen41 from "../../assets/Sample/queenteen.jpg";

import race20 from "../../assets/Sample/race20new.jpg";
import lucky7eu2 from "../../assets/Sample/lucky7cnew.jpg";

import FiveCricket from "../../assets/Sample/fivecricket.jpg";
import cmatch20 from "../../assets/Sample/CricketMatch20.jpg";

// CricketMatch20
// import AndharBharTwo from "../../assets/Sample/Andar-Bahar-2.png";
import AndharBharTwo from "../../assets/Sample/ab2new.jpg";

import DrangonTigertw from "../../assets/Sample/20-20-Drangon-Tiger.png";
// import DrangonTigertwNew from "../../assets/Sample/20-20-Drangon-Tiger-Two.png";
import dt202 from "../../assets/Sample/dt20202new.jpg";

// import Bacart from "../../assets/Sample/Baccarat.png";
import Bacart from "../../assets/Sample/baccaratnew.jpg";

// import BacartTwo from "../../assets/Sample/Baccarat-2.png";
import BacartTwo from "../../assets/Sample/baccarat2new.jpg";

// import Luckysevan from "../../assets/Sample/Lucky-7-B.png";
import lucky7eu from "../../assets/Sample/lucky7eunewjpg.jpg";

import war from "../../assets/Sample/warnew.jpg";
import worli from "../../assets/Sample/worlimatka.jpg";

import DTL from "../../assets/Sample/20-20-DTL.png";
import CasinoMeter from "../../assets/Sample/cmeternew.jpg";
import teen6 from "../../assets/Sample/teenpatti2new.jpg";

// import TeenPattiOpen from "../../assets/Sample/Open-Teen-Patti.png";
import teen8 from "../../assets/Sample/teenpattiopen.jpg";

// import TweentyTweentyTeenPatti from "../../assets/Sample/Teen-Patti-20-20.png";
import teen20 from "../../assets/Sample/teenpatti20-20.jpg";

import queen from "../../assets/Sample/queennew.jpg";
// import ThirtytwoCardA from "../../assets/Sample/32-Cards-A.png";
import card32 from "../../assets/Sample/card32anew.jpg";

import teen from "../../assets/Sample/Teen-Patti-1-Day.png";
// import TeenPattiTest from "../../assets/Sample/Teen-Patti-Test.png";

import teen9 from "../../assets/Sample/teenpattitest.jpg";

// import OneDayDregonTiger from "../../assets/Sample/Dragon-Tiger-1-Day.png";
import dt6 from "../../assets/Sample/dt6new.jpg";
import dtl20 from "../../assets/Sample/dtl20new.jpg";

// import PokeroneDay from "../../assets/Sample/Poker1-Day.png";
// pokeroneday.jpg
import poker from "../../assets/Sample/pokeroneday.jpg";
import poker6 from "../../assets/Sample/pokersix.jpg";

// import TwentyTwentyPoker from "../../assets/Sample/Poker-20-20.png";
// poker20-20.jpg
import poker20 from "../../assets/Sample/poker20-20.jpg";

// import TwentyTwentyDregonTiger from "../../assets/Sample/20-20-Drangon-Tiger.png";
import dt20 from "../../assets/Sample/dt20new.jpg";

// import ThirtytwoCardB from "../../assets/Sample/32-Cards-B.png";
import card32eu from "../../assets/Sample/card32eunew.jpg";

// import AndharBhar from "../../assets/Sample/Andar-Bahar.png";
import AndharBhar from "../../assets/Sample/abnew.jpg";
// import LuckySevanA from "../../assets/Sample/Lucky-7-A.png";
import lucky7 from "../../assets/Sample/lucky7anew.jpg";

import worli2 from "../../assets/Sample/worli2new.jpg";
import AmerAkbarAnthony from "../../assets/Sample/aaanew.jpg";
import btable from "../../assets/Sample/btablenew.jpg";
import CricketMatchTwentyTwenty from "../../assets/Sample/Cricket-20-20.png";
import joker20 from "../../assets/Sample/joker20.jpg";
import joker1 from "../../assets/Sample/joker1.jpg";
import teenjoker from "../../assets/Sample/teenjoker.jpg";
import teen20c from "../../assets/Sample/teen20c.jpg";
import btable2 from "../../assets/Sample/btable2.jpg";
import ourroullete from "../../assets/Sample/ourroullete.jpg";
import superover3 from "../../assets/Sample/superover3.jpg";
import sicbo from "../../assets/Sample/sicbonew.jpg";

import ballbyball from "../../assets/Sample/ballbyballnew.jpg";

import goal from "../../assets/Sample/goal.jpg";
import ab4 from "../../assets/Sample/ab4.jpg";
import lucky15 from "../../assets/Sample/lucky15.jpg";
import superover2 from "../../assets/Sample/superover2.jpg";
import goldenroulette2 from "../../assets/Sample/goldenroulette2.jpg";
import sicbo2 from "../../assets/Sample/sicbo2new.jpg";
import teen42 from "../../assets/Sample/jackteen.jpg";
import beachroulette from "../../assets/Sample/beachroulette.jpg";
// import teen41 from "../../assets/Sample/teen41.jpg";
// import teen42 from "../../assets/Sample/teen42.jpg";
import roulette3 from "../../assets/Sample/roulette3.jpg";
// import sicbo2 from "../../assets/Sample/sicbo2.jpg";
import roulette2 from "../../assets/Sample/roulette2.jpg";
import teen33 from "../../assets/Sample/teen33.jpg";
// import sicbo from "../../assets/Sample/sicbo.jpg";
// import ballbyball from "../../assets/Sample/ballbyball.jpg";
import teen32 from "../../assets/Sample/teen32.jpg";
import roulette1 from "../../assets/Sample/roulette1.jpg";
// import dtl20 from "../../assets/Sample/dtl20.jpg";
// import threecardj from "../../assets/Sample/3cardj.jpg";
import threecardj from "../../assets/Sample/cardjudgement3.jpg";

// import worli from "../../assets/Sample/worli.jpg";
import lottcard from "../../assets/Sample/lottery.jpg";
// import teen6 from "../../assets/Sample/teen6.jpg";
// import lucky7eu2 from "../../assets/Sample/lucky7eu2.jpg";
import trap from "../../assets/Sample/trapnew.jpg";
import patti2 from "../../assets/Sample/card2teenpatti.jpg";
import teensin from "../../assets/Sample/baccarat29.jpg";
import teenmuf from "../../assets/Sample/muflisteenpatti.jpg";
import race17 from "../../assets/Sample/race17new.jpg";
import teen20b from "../../assets/Sample/teenpatti2020b.jpg";

// import teensin from "../../assets/Sample/teensin.jpg";
// import teenmuf from "../../assets/Sample/teenmuf.jpg";
// import race17 from "../../assets/Sample/race17.jpg";
// import teen20b from "../../assets/Sample/teen20b.jpg";
import trio from "../../assets/Sample/triosnew.jpg";
import notenum from "../../assets/Sample/notenumbernew.jpg";
import kbc from "../../assets/Sample/crorepatti.jpg";
import teen120 from "../../assets/Sample/cardone2020.jpg";
import teen1 from "../../assets/Sample/onecard.jpg";
import Roulette from "../../assets/Sample/roulettenew.jpg";
import ab3 from "../../assets/Sample/ab50cards.jpg";
import aaa2 from "../../assets/Sample/aaa2new.jpg";
import race2 from "../../assets/Sample/race2new.jpg";
import teen3 from "../../assets/Sample/instantteenpattinew.jpg";
import dum10 from "../../assets/Sample/dum10new.jpg";
import cmeter1 from "../../assets/Sample/onecardmeter.jpg";
import { Link } from "react-router-dom";
// import kbc from "../../assets/Sample/kbc.jpg";

const Home = () => {
  const { game } = useParams();
  // const navigate = useNavigate();
  // const handleClick = (e) => {
  //   e.preventDefault();

  //   if (!selectedGameType || !game) {
  //     console.error("Missing game or game type");
  //     return;
  //   }

  //   const gameType = selectedGameType.toLowerCase();
  //   const gameIdKey = gameType + "Id";
  //   const gameId = game[gameIdKey];

  //   console.log("Navigating to:", `/game/${gameType}/${gameId}`);

  //   if (!gameId) {
  //     console.error(`Missing ID for type: ${gameType}`);
  //     return;
  //   }

  //   navigate(`/game/${gameType}/${gameId}`);
  // };

  const userData = useSelector((state) => state.account.userData);
  const dispatch = useDispatch();
  const [matchList, setMatchList] = useState({
    cricket: [],
    soccer: [],
    tennis: [],
  });
  const [selectedGameType, setSelectedGameType] = useState(
    game ? game : "cricket"
  );
  const [gameData, setGameData] = useState([]);
  const getUserData = useCallback(async () => {
    if (userData.token) {
      var { response, code } = await getUserDataAPI(userData.id);
      if (code === 200) {
        dispatch({
          type: "accountData/setUserProfile",
          payload: response,
        });
      }
    }
  }, [userData.id]);
  const getBannerImages = async () => {
    var { response, code } = await dashboardBannerAPI();
    if (code === 200) {
      //setHomeImages(response);
    }
  };
  const getSoccerMatches = async () => {
    const { response, code } = await getAllMatchesOddsSoccerAPI();
    if (code == 200) {
      setGameData(response);
    }
  };
  const getTennisMatches = async () => {
    const { response, code } = await getAllMatchesOddsTennisAPI();
    if (code == 200) {
      setGameData(response);
    }
  };
  const getCricketMatches = async () => {
    const { response, code } = await getAllMatchesOddsCricketAPI();
    if (code == 200) {
      if (selectedGameType === "politics") {
        setGameData(
          response.filter((game) => game?.eventName?.includes("ELECTION"))
        );
      } else {
        setGameData(
          response.filter((game) => !game?.eventName?.includes("ELECTION"))
        );
      }
    }
  };
  useEffect(() => {
    let interval;

    getCricketMatches();

    if (selectedGameType === "soccer") {
      interval = setInterval(() => {
        getSoccerMatches();
      }, 2000);
    } else if (selectedGameType === "tennis") {
      interval = setInterval(() => {
        getTennisMatches();
      }, 2000);
    } else {
      interval = setInterval(() => {
        getCricketMatches();
      }, 2000);
    }
    return () => clearInterval(interval);
  }, [selectedGameType]);
  const getCricketData = async () => {
    const { response } = await getAllCricketMatchListAPI();
    setMatchList((prev) => ({ ...prev, cricket: response }));
  };
  const getSoccerData = async () => {
    const { response } = await getAllSoccerMatchListAPI();
    setMatchList((prev) => ({ ...prev, soccer: response }));
  };
  const getTennisData = async () => {
    const { response } = await getAllTennisMatchListAPI();
    setMatchList((prev) => ({ ...prev, tennis: response }));
  };
  const navigate = useNavigate();
  const navigateToColorPrediction = () => {

    navigate("/color-prediction");
  };
  useEffect(() => {
    if (userData) {
      getUserData();
    }
    getCricketData();
    getSoccerData();
    getTennisData();
  }, []);
  return (
    <>
      <div className="latest-event d-xl-none">
        {matchList?.cricket?.slice(0, 4)?.map((match) => (
          <div className="latest-event-item">
            <a className="blink_me" href={`/game/cricket/${match?.cricketId}`}>
              <i class="d-icon icon-4" />
              <span>{match?.eventName}</span>
            </a>
          </div>
        ))}
      </div>
      <ul className="nav nav-tabs d-xl-none menu-tabs">
        {/* <li className="nav-item">
          <a className="nav-link" href="/sports-book/33">
            Lottery
          </a>
        </li> */}
        <li className="nav-item">
          <a aria-current="page" className="nav-link active" href="/home">
            Sports
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/casino-page">
            Our Casino
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/international">
            Our Virtual
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/international/SPRIBE">
            Slots
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/international/sevenMOJOS">
            <span>Seven Mojos</span>
          </a>
        </li>
      </ul>
      <div className="center-main-container home-page">
        <div className="center-container">
          <div className="latest-event d-none d-xl-flex">
            {matchList?.cricket
              ?.slice(
                0,
                matchList?.cricket?.length > 4 ? 4 : matchList?.cricket?.length
              )
              ?.map((match) => (
                <div className="latest-event-item ">
                  <a
                    className="blink_me"
                    href={`/game/cricket/${match?.cricketId}`}
                  >
                    <i className="d-icon me-1 icon-4" />
                    <span>{match?.eventName}</span>
                  </a>
                </div>
              ))}
          </div>
          <ul className="nav nav-pills sports-tab">
            {/* <li className="nav-item">
              <a
                onClick={() => {
                  getCricketMatches();
                  setSelectedGameType("politics");
                }}
                className={`nav-link ${selectedGameType == "politics" &&
                  "active"}`}
              >
                <div className="d-xl-none">
                  <i className="icon icon-40" />
                </div>
                <span>Politics</span>
              </a>
            </li> */}
           
            <li className="nav-item">
              <a
                onClick={() => {
                  getCricketMatches();
                  setSelectedGameType("cricket");
                }}
                className={`nav-link ${selectedGameType == "cricket" &&
                  "active"}`}
              >
                <div className="d-xl-none">
                  <i className="icon icon-4" />
                </div>
                <span>Cricket</span>
              </a>
            </li>
            <li className="nav-item">
              <a
                onClick={() => {
                  getSoccerMatches();
                  setSelectedGameType("soccer");
                }}
                className={`nav-link ${selectedGameType == "soccer" &&
                  "active"}`}
              >
                <div className="d-xl-none">
                  <i className="icon icon-1" />
                </div>
                <span>Football</span>
              </a>
            </li>
            <li className="nav-item">
              <a
                onClick={() => {
                  getTennisMatches();
                  setSelectedGameType("tennis");
                }}
                className={`nav-link ${selectedGameType == "tennis" &&
                  "active"}`}
              >
                <div className="d-xl-none">
                  <i className="icon icon-2" />
                </div>
                <span>Tennis</span>
              </a>
            </li>
 <li className="nav-item">
              <a
                onClick={() => {
                  navigateToColorPrediction();
                }}
                className={`nav-link`}
              >
                <div className="d-xl-none">
                  <i className="icon icon-11" />
                </div>
                <span>Color Prediction</span>
              </a>
            </li>
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-66" />
                </div>
                <span>Kabaddi</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-68" />
                </div>
                <span>Esoccer</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-10" />
                </div>
                <span>Horse Racing</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-65" />
                </div>
                <span>Greyhound Racing</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-8" />
                </div>
                <span>Table Tennis</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-15" />
                </div>
                <span>Basketball</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-6" />
                </div>
                <span>Boxing</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-3" />
                </div>
                <span>Mixed Martial Arts</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-58" />
                </div>
                <span>American Football</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-18" />
                </div>
                <span>Volleyball</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-22" />
                </div>
                <span>Badminton</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-59" />
                </div>
                <span>Snooker</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-19" />
                </div>
                <span>Ice Hockey</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-11" />
                </div>
                <span>E Games</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-9" />
                </div>
                <span>Futsal</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-39" />
                </div>
                <span>Handball</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link">
                <div className="d-xl-none">
                  <i className="icon icon-52" />
                </div>
                <span>Motor Sports</span>
              </a>
            </li> */}
          </ul>
          <div className="tab-content mt-1">
            <div className="tab-pane active">
              <div className="bet-table">
                <div className="bet-table-header">
                  <div className="bet-nation-name">
                    <b>Game</b>
                  </div>
                  <div className="bet-nation-odd">
                    <b>1</b>
                  </div>
                  <div className="bet-nation-odd">
                    <b>X</b>
                  </div>
                  <div className="bet-nation-odd">
                    <b>2</b>
                  </div>
                </div>
                <div className="bet-table-body">
                  {gameData?.map((game, index) => (
                    <div className="bet-table-row">
                      <div className="bet-nation-name">
                        {/* <a
                          className="bet-nation-game-name"
                                  href={`/game/${selectedGameType.toLowerCase()}/${
                                    game[selectedGameType.toLowerCase() + "Id"]
                                  }
                           `}
                          
                        >
                          <span>{game?.eventName}</span>
                          {moment(
                            game?.eventDate ? game?.eventDate : game?.eventTime
                          ).format("DD-MM-YYYY HH:mm A")}
                        </a> */}
                        <Link
                          className="bet-nation-game-name"
                          to={`/game/${selectedGameType.toLowerCase()}/${
                            game[selectedGameType.toLowerCase() + "Id"]
                          }`}
                        >
                          <span>{game?.eventName}</span>
                          {moment(game?.eventDate ?? game?.eventTime).format(
                            "DD-MM-YYYY HH:mm A"
                          )}
                        </Link>

                        <div className="game-icons">
                          <div className="game-icon">
                            {game?.inPlay && <span className="active" />}
                          </div>
                          <div className="game-icon">
                            <i className="fas fa-tv icon-tv" />
                          </div>
                          <div className="game-icon">
                            <img src={require("../../assets/ic_fancy.png")} />
                          </div>
                          <div className="game-icon">
                            <img src={require("../../assets/ic_bm.png")} />
                          </div>
                          <div className="game-icon" />
                        </div>
                      </div>
                      <div class="bet-nation-odd d-xl-none">
                        <b>1</b>
                      </div>
                      <div class="bet-nation-odd d-xl-none">
                        <b>X</b>
                      </div>
                      <div class="bet-nation-odd d-xl-none">
                        <b>2</b>
                      </div>
                      <div className="bet-nation-odd">
                        <div className="back odd-box">
                          <span className="bet-odd">
                            {game?.back1 ? game?.back1 : <b>-</b>}
                          </span>
                        </div>
                        <div className="lay odd-box">
                          <span className="bet-odd">
                            {game?.lay1 ? game?.lay1 : <b>-</b>}
                          </span>
                        </div>
                      </div>
                      <div className="bet-nation-odd">
                        <div className="back odd-box">
                          <span className="bet-odd">
                            {game?.back11 ? game?.back11 : <b>-</b>}
                          </span>
                        </div>
                        <div className="lay odd-box">
                          <span className="bet-odd">
                            {game?.lay11 ? game?.lay11 : <b>-</b>}
                          </span>
                        </div>
                      </div>
                      <div className="bet-nation-odd">
                        <div className="back odd-box">
                          <span className="bet-odd">
                            {game?.back12 ? game?.back12 : <b>-</b>}
                          </span>
                        </div>
                        <div className="lay odd-box">
                          <span className="bet-odd">
                            {game?.lay12 ? game?.lay12 : <b>-</b>}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {/*  <div className="casino-list mt-2">
            <div className="casino-list-item">
              <a href="/casino/superover3">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/superover3.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Mini Superover</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/goal">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/goal.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Goal</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/ab4">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/ab4.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">ANDAR BAHAR 150 cards</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/lucky15">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/lucky15.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Lucky 15</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/superover2">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/superover2.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Super Over2</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/teen41">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/teen41.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">
                  Queen Top Open Teenpatti
                </div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/teen42">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/teen42.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">
                  Jack Top Open Teenpatti
                </div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino-list/LC/4/31">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/roulette3.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Roulette</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/sicbo2">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/sicbo2.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Sic Bo2</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino-list/LC/4/31">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/roulette2.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Roulette</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/teen33">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/teen33.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Instant Teenpatti 3.0</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/sicbo">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/sicbo.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Sic Bo</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/ballbyball">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/ballbyball.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Ball by Ball</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/teen32">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/teen32.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Instant Teenpatti 2.0</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino-list/LC/4/31">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/roulette1.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Roulette</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/teen">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/teen.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Teenpatti 1-day</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/teen20">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/teen20.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">20-20 Teenpatti</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/teen9">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/teen9.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Teenpatti Test</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/teenpattiopen">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/teen8.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Teenpatti Open</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/poker">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/poker.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Poker 1-Day</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/poker20">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/poker20.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">20-20 Poker</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/poker6">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/poker6.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Poker 6 Players</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/baccarat">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/baccarat.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Baccarat</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/baccarat2">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/baccarat2.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Baccarat 2</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/dt20">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/dt20.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">20-20 Dragon Tiger</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/dt6">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/dt6.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">1 Day Dragon Tiger</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/dtl20">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/dtl20.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">20-20 D T L</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/dt202">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/dt202.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">20-20 Dragon Tiger 2</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/card32">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/card32.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">32 Cards A</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/card32eu">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/card32eu.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">32 Cards B</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/ab20">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/ab20.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Andar Bahar</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/abj">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/abj.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Andar Bahar 2</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/lucky7">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/lucky7.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Lucky 7 - A</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/lucky7eu">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/lucky7eu.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Lucky 7 - B</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/3cardj">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/3cardj.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">3 Cards Judgement</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/war">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/war.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Casino War</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/worli2">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/worli.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Worli Matka</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/worli">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/worli2.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Instant Worli</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/aaa">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/aaa.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Amar Akbar Anthony</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/btable">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/btable.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Bollywood Casino</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/lottcard">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/lottcard.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Lottery</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/cricketv3">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/cricketv3.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">5Five Cricket</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/cmatch20">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/cmatch20.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Cricket Match 20-20</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/cmeter">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/cmeter.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Casino Meter</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/teen6">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/teen6.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Teenpatti - 2.0</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/queen">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/queen.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Queen</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/race20">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/race20.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Race20</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/lucky7eu2">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/lucky7eu2.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Lucky 7 - C</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/superover">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/superover.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Super Over</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/trap">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/trap.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">The Trap</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/patti2">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/patti2.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">2 Cards Teenpatti</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/teensin">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/teensin.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">29Card Baccarat</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/teenmuf">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/teenmuf.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Muflis Teenpatti</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/race17">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/race17.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Race To 17</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/teen20b">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/teen20b.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">20-20 Teenpatti B</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/trio">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/trio.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Trio</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/notenum">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/notenum.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Note Number</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/kbc">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/kbc.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">K.B.C</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/teen120">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/teen120.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">1 CARD 20-20</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/teen1">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/teen1.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">1 CARD ONE-DAY</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino-list/LC/4/31">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/roulette.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Roulette</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/ab3">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/ab3.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">ANDAR BAHAR 50 cards</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/aaa2">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/aaa2.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Amar Akbar Anthony 2</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/race2">
                <div 
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/race2.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Race to 2nd</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/teen3">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/teen3.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Instant Teenpatti</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/dum10">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/dum10.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Dus ka Dum</div>
              </a>
            </div>
            <div className="casino-list-item">
              <a href="/casino/cmeter1">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/cmeter1.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">1 Card Meter</div>
              </a>
            </div>
          </div> */}
          <div className="casino-list mt-2">
            {/* <div className="casino-list-item">
              <a href="/casino/ballbyball">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/ballbyball.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Ball by Ball</div>
              </a>
            </div> */}

            <div className="casino-list-item">
              <Link to="/casino/superover3">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${superover3}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Mini Superover </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/lucky15">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${lucky15}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Lucky 15 </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/superover2">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${superover2}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Super Over2 </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/teen41">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen41}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Super Over2 </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/teen42">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen42}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Super Over2 </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/teen33">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen33}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Instant Teenpatti 3.0 </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/ballbyball">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${ballbyball}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Instant Teenpatti 3.0 </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/teen32">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen32}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Instant Teenpatti 2.0 </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/teen">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Teenpatti 1-day</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/teen20">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen20}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">20-20 Teenpatti</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/teen9">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen9}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Teenpatti Test</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/teen8">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen8}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Teenpatti Open</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/poker">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${poker}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Poker 1-Day</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/poker20">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${poker20}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">20-20 Poker</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/poker6">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${poker6}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Poker 1-Day</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/baccarat">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${Bacart}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Baccarat</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/baccarat2">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${BacartTwo}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Baccarat 2</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/dt20">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${dt20}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">20-20 Dragon Tiger</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/dt6">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${dt6}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">1 Day Dragon Tiger</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/dtl20">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${dtl20}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">1 Day Dragon Tiger</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/dt202">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${dt202}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">20-20 Dragon Tiger 2</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/card32">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${card32}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">32 Cards A</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/card32eu">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${card32eu}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">32 Cards B</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/ab20">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${AndharBhar}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Andar Bahar</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/abj">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${AndharBharTwo}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Andar Bahar 2</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/lucky7">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${lucky7}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Lucky 7 - A</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/lucky7eu">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${lucky7eu}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Lucky 7 - B</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/war">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${war}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Casino War</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/worli2">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${worli2}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Instant Worli</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/aaa">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${AmerAkbarAnthony}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Amar Akbar Anthony</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/btable">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${btable}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Bollywood Casino</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/cricketv3">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${FiveCricket}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">5Five Cricket</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/cmeter">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${CasinoMeter}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Casino Meter</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/teen6">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen6}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Casino Meter</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/queen">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${queen}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Casino Queen</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/race20">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${race20}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Race20</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/lucky7eu2">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${lucky7eu2}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Race20</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/superover">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${superover}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />

                {/* <div className="casino-list-name">Super Over</div> */}
              </Link>
            </div>

            {/* <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${Trap}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name"> The Trap </div>
              </Link>
            </div> */}

            <div className="casino-list-item">
              <Link to="/casino/patti2">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${patti2}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> 2 Cards Teenpatti </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/teensin">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teensin}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> 2 Cards Teenpatti </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/teenmuf">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teenmuf}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> 2 Cards Teenpatti </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/teen20b">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen20b}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> 2 Cards Teenpatti </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/trio">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${trio}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Trio </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/teen120">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen120}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Note Number </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/teen1">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen1}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Note Number </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/ab3">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${ab3}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Note Number </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/aaa2">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${aaa2}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Note Number </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/race2">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${race2}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Note Number </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/teen3">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen3}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Note Number </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/dum10">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${dum10}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Note Number </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/cmeter1">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${cmeter1}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Note Number </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/teen20c">
                {/* <Link to=""> */}
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen20c}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> 20-20 Teenpatti C </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              {/* <Link to="/casino/joker20"> */}
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${joker20}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Joker 20-20</div> */}

                {/* <div className="casino-list-name" > Teenpatti Joker 20-20</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              {/* <Link to="/casino/joker1"> */}
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${joker1}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Unlimited Joker Oneday </div> */}

                {/* <div className="casino-list-name" > Teenpatti Joker 20-20</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              {/* <Link to="/casino/teenjoker"> */}
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teenjoker}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Teenpatti Joker </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="/casino/btable2">
                {/* <Link to=""> */}
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${btable2}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Bollywood Casino 2 </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              {/* <Link to="/casino/ourroullete"> */}
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${ourroullete}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Unique Roulette </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              {/* <Link to="/casino/sicbo2"> */}
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${sicbo2}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Super Over2 </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${goldenroulette2}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Super Over2 </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              {/* <Link to="/casino/sicbo"> */}
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${sicbo}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Instant Teenpatti 3.0 </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              {/* <Link to="/casino/trap"> */}
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${trap}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Note Number </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              {/* <Link to="/casino/race17"> */}
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${race17}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> 2 Cards Teenpatti </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              {/* <Link to="/casino/cmatch20"> */}
              {/* <Link to="/casino/cmatch"> */}
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${cmatch20}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">5Five Cricket</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              {/* <Link to="/casino/3cardj"> */}
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${threecardj}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> 3 Cards Judgement </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              {/* <Link to="/casino/notenum"> */}
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${notenum}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Note Number </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              {/* <Link to="/casino/ab4"> */}
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${ab4}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">ANDAR BAHAR 150 cards </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${beachroulette}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Super Over2 </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${roulette1}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Roulette BL </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              {/* <Link to="/casino/worli"> */}
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${worli}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">Casino War</div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              {/* <Link to="/casino/lottcard"> */}
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${lottcard}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Lottery </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${kbc}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${Roulette}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name"> Note Number </div> */}
              </Link>
            </div>

            <div className="casino-list-item">
              {/* <Link to="/casino/goal"> */}
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${goal}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                {/* <div className="casino-list-name">goal </div> */}
              </Link>
            </div>

            {/* <div className="casino-list-item">
              <Link to="/casino/dtl20">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      `url(${DTL}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name">20-20 D T L</div>
              </Link>
            </div> */}

            {/*   <div className="casino-list-item">
              <Link to="/casino/poker6">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      'url("https://dataobj.ecoassetsservice.com/casino-icons/lc/poker6.jpg"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")',
                  }}
                />
                <div className="casino-list-name">Poker 6 Players</div>
              </Link>
            </div> */}

            {/* <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen41}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name">
                  {" "}
                  Queen Top Open Teenpatti{" "}
                </div>
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen42}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name">
                  {" "}
                  Jack Top Open Teenpatti{" "}
                </div>
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${roulette3}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name"> Beach Roulette </div>
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${sicbo2}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name"> Sic Bo2 </div>
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${roulette2}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name"> Golden Roulette </div>
              </Link>
            </div>

          

         

         
           
          

            <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${dtl20}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name"> 20-20 D T L </div>
              </Link>
            </div>

           

            <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${worli}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name"> Worli Matka </div>
              </Link>
            </div>

           

            <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen6}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name"> Teenpatti - 2.0 </div>
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${lucky7eu2}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name"> Lucky 7 - C </div>
              </Link>
            </div>

           

           

            <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teensin}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name"> 29Card Baccarat </div>
              </Link>
            </div>

            <div className="casino-list-item">
              <Link to="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teenmuf}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name"> Muflis Teenpatti </div>
              </Link>
            </div>

            <div className="casino-list-item">
              <Link href="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${race17}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name"> Race To 17 </div>
              </Link>
            </div>

            <div className="casino-list-item">
              <Link href="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${teen20b}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name"> 20-20 Teenpatti B </div>
              </Link>
            </div>

           

          

            <div className="casino-list-item">
              <Link href="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${kbc}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name"> K.B.C </div>
              </Link>
            </div> */}

            {/* <div className="casino-list-item">
              <Link href="">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage: `url(${race17}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name">
                  {" "}
                  Race To 17  {" "}
                </div>
              </Link>
            </div> */}

            {/* <div className="casino-list-item">
              <a href="/casino/cmatch">
                <div
                  className="casino-list-item-banner"
                  style={{
                    backgroundImage:
                      `url(${CricketMatchTwentyTwenty}), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")`,
                  }}
                />
                <div className="casino-list-name">Cricket Match 20</div>
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
